// extracted by mini-css-extract-plugin
export var backdropBlur = "_ee-0";
export var contentCard = "_ee-5";
export var frame = "_ee-2";
export var image = "_ee-4";
export var imagePane = "_ee-3";
export var modal = "_ee-1";